module.exports = __webpack_public_path__ + "static/media/menu-icon.23a9188c.svg";